export type FunnelFeatureValue = {
  flow: string | Record<string, string>;
};

export const funnelFeatureDefaultValue: FunnelFeatureValue = { flow: 'default_flow' };
